// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      // === COMPOSANTS GLOBAUX ===
      nav_home: "Accueil",
      nav_about: "À propos",
      nav_destinations: "Destinations",
      nav_schedule: "Horaires",
      nav_booking: "Réserver",
      nav_contact: "Contact",
      nav_legal: "Mentions légales",
      nav_suggestion: "💡 Suggestions",
      bus_company: "Express Abou Hamama",
      or: "OU",
      and: "et",
      to_view_reservations: "pour voir le nombre de places déjà réservées",

      // Footer
      quick_links: "Liens rapides",
      information: "Informations",
      contact: "Contact",
      agency_address: "Dembe, Quartier Sabangali",
      all_rights_reserved: "Tous droits réservés",
      footer_description: "Transport interurbain fiable et sécurisé au Tchad depuis 2014",

      // === PAGE SUGGESTION ===
      suggestions_title: "Suggestions",
      suggestions_subtitle: "Partagez vos idées pour améliorer nos services",
      suggestions_form_title: "Vos suggestions nous intéressent",
      suggestions_description: "Aidez-nous à améliorer nos services en nous faisant part de vos remarques, idées ou préoccupations.",
      email_required: "Email obligatoire",
      full_name: "Nom complet *",
      email_address: "Email *",
      phone_number: "Téléphone",
      suggestion_category: "Catégorie *",
      select_category: "Sélectionnez une catégorie",
      category_service: "Service client",
      category_booking: "Réservation",
      category_route: "Proposition de trajet",
      category_price: "Tarifs",
      category_comfort: "Confort du bus",
      category_other: "Autre",
      category_required: "Veuillez choisir une catégorie",
      your_suggestion: "Votre suggestion *",
      suggestion_placeholder: "Décrivez votre suggestion en détail...",
      suggestion_required: "La suggestion est obligatoire",
      suggestion_min_length: "Minimum 10 caractères",
      sending_suggestion: "⏳ Envoi en cours...",
      send_my_suggestion: "📨 Envoyer ma suggestion",
      suggestion_success_message: "Merci pour votre suggestion ! Nous l'étudierons attentivement.",
      innovative_ideas: "Idées innovantes",
      innovative_ideas_desc: "Nous sommes ouverts à toutes vos propositions pour améliorer nos services.",
      quick_response: "Réponse rapide",
      quick_response_desc: "Nous vous répondrons dans les 48 heures pour toute suggestion.",
      collaboration: "Collaboration",
      collaboration_desc: "Votre avis compte et nous aide à nous améliorer chaque jour.",

      // === PAGE ACCUEIL ===
      hero_title: "Voyagez Serein",
      hero_subtitle: "Réservez votre billet en ligne en 2 minutes chrono",
      search_departure: "Départ",
      search_arrival: "Arrivée",
      search_date: "Date",
      search_button: "🔍 Rechercher",
      popular_destinations: "Destinations Populaires",
      popular_destinations_desc: "Choisissez parmi nos lignes les plus demandées",
      why_choose_us: "Pourquoi nous choisir ?",
      security: "Sécurité Garantie",
      security_desc: "Chauffeurs certifiés, bus entretenus quotidiennement et assurance complète",
      punctuality: "Ponctualité",
      punctuality_desc: "Départs à l'heure garantis avec suivi GPS en temps réel",
      comfort: "Confort Premium",
      comfort_desc: "Sièges ergonomiques, climatisation et espace pour les jambes",
      ready_to_travel: "Prêt à voyager ?",
      ready_to_travel_desc: "Réservez votre billet maintenant et profitez d'un voyage confortable et sécurisé",
      book_now: "🎫 Réserver maintenant",
      fleet_buses: "Bus dans la flotte",
      destinations_count: "Destinations",
      passengers_month: "Passagers/mois",
      satisfaction_rate: "Satisfaction",
      services_designed_for_comfort: "Des services conçus pour votre confort",
      see_details: "Voir détails",
      travel_time: "de trajet",
      choose_departure_first: "Choisissez d'abord le départ",

      // === PAGE DESTINATIONS ===
      destinations_title: "Nos Destinations",
      destinations_subtitle: "Découvrez toutes nos lignes de bus à partir de nos principales villes de départ",
      all_routes: "Toutes",
      from_ndjamena: "Depuis N'Djaména",
      morning_departures: "Départs matin",
      daily: "Quotidien",
      popular: "POPULAIRE",
      book: "Réserver",
      capacity: "55 places",
      air_conditioned: "Climatisé",
      toilets: "Toilettes",
      view_schedules: "Voir les horaires",
      no_routes_found: "Aucun trajet trouvé pour cette recherche.",
      reset_filters: "Réinitialiser",
      starting_price: "À partir de",

      // === PAGE HORAIRES ===
      schedules_title: "Horaires & Tarifs",
      schedules_subtitle: "Consultez tous nos horaires et trouvez le trajet qui vous convient",
      route: "Trajet",
      departure: "Départ",
      arrival: "Arrivée",
      price: "Prix",
      days: "Jours",
      action: "Action",
      book_ticket: "Réserver",
      flexible_ticket: "Billet flexible",
      flexible_ticket_desc: "Modification gratuite jusqu'à 24h avant",
      secure_payment: "Paiement sécurisé",
      secure_payment_desc: "Mobile Money ou espèces à bord",
      e_ticket: "E-billet",
      e_ticket_desc: "Reçu par SMS/email immédiatement",
      duration: "Durée",
      frequency: "Fréquence",
      seat: "siège",

      // === PAGE À PROPOS ===
      about_title: "Notre Histoire",
      about_subtitle: "Express Abou Hamama, transporteur de confiance au Tchad depuis plus de 10 ans",
      about_who_we_are: "Qui sommes-nous ?",
      about_description: "Express Abou Hamama est une entreprise de transport interurbain par bus basée au Tchad. Nous connectons les principales villes du pays avec des services fiables, sécurisés et confortables.",
      about_mission: "Notre Mission",
      about_mission_text: "Offrir un transport moderne et accessible à tous les Tchadiens, avec un service client irréprochable et des horaires respectés. Nous mettons la sécurité de nos passagers au cœur de nos préoccupations.",
      about_vision: "Notre Vision",
      about_vision_text: "Devenir le premier transporteur interurbain du Tchad, reconnu pour notre excellence opérationnelle et notre contribution au développement du pays.",
      about_values_title: "Nos Valeurs",
      about_values_subtitle: "Ce qui nous guide chaque jour",
      about_security: "Sécurité",
      about_security_desc: "Chauffeurs certifiés, bus entretenus quotidiennement",
      about_punctuality: "Ponctualité",
      about_punctuality_desc: "Respect strict des horaires avec suivi GPS",
      about_comfort: "Confort",
      about_comfort_desc: "Climatisation, sièges ergonomiques, espace généreux",
      about_service: "Service",
      about_service_desc: "Equipe dévouée à votre satisfaction",
      about_fact: "Saviez-vous ?",
      about_fact_text: "Notre flotte compte plus de 20 bus et nous transportons plus de 5 000 passagers par mois sur l'ensemble du territoire tchadien !",

      // === PAGE RÉSERVATION ===
      search_trip: "Sélectionner votre trajet",
      booking_title: "Réserver votre billet",
      select_trip: "1. Choisissez votre trajet",
      select_seats: "2. Choisissez vos sièges",
      passenger_information: "Informations passager",
      first_name: "Prénom",
      last_name: "Nom",
      phone: "Téléphone",
      payment_method: "Mode de paiement",
      airtel_money: "Airtel Money",
      moov_money: "Moov Money",
      cash_agency: "Paiement en agence",
      total_to_pay: "Total à payer",
      confirm_booking: "Confirmer la réservation",
      select_seats_first: "Sélectionnez au moins un siège",
      seats_selected: "sièges sélectionnés",
      seats_occupied: "sièges occupés",
      booking_success: "✅ Réservation réussie !",
      booking_success_message: "Votre billet a bien été enregistré dans notre système.",
      booking_ref: "Référence de réservation :",
      download_ticket: "📄 Télécharger le billet (format billet)",
      copy_ref: "Copier la référence",
      back_home: "Retour à l'accueil maintenant",
      redirect_home: "Vous serez redirigé vers l'accueil dans 1 minute.",
      no_trip_selected: "Veuillez sélectionner un trajet.",
      select_at_least_one_seat: "Veuillez choisir au moins un siège.",
      fill_passenger_info: "Veuillez renseigner les informations du passager.",
      reservation_error: "Erreur lors de la réservation.",
      please_fill_all_fields: "Veuillez remplir tous les champs",
      
      // === PAGE CONTACT ===
      contact_title: "Contactez-nous",
      contact_subtitle: "Notre équipe est là pour répondre à toutes vos questions",
      contact_main_agency: "Agence principale",
      contact_phones: "Téléphones",
      contact_hours_value: "Lundi-Dimanche: 06h00-22h00",
      contact_email: "Email & Support",
      contact_form_title: "Formulaire de contact",
      contact_name: "Nom complet",
      contact_name_placeholder: "Jean Dupont",
      contact_name_required: "Le nom est obligatoire",
      contact_name_min: "Minimum 3 caractères",
      contact_phone: "Téléphone",
      contact_phone_placeholder: "+235 66 12 34 56",
      contact_phone_required: "Le téléphone est obligatoire",
      contact_phone_invalid: "Format: +23566123456 ou 66 12 34 56",
      contact_email: "Email",
      contact_email_placeholder: "jean@email.com",
      contact_email_invalid: "Email invalide",
      contact_subject: "Objet",
      contact_subject_select: "Sélectionnez un objet",
      contact_subject_booking: "Réservation",
      contact_subject_info: "Informations",
      contact_subject_complaint: "Réclamation",
      contact_subject_other: "Autre",
      contact_subject_required: "L'objet est obligatoire",
      contact_message: "Message",
      contact_message_placeholder: "Votre message détaillé...",
      contact_message_required: "Le message est obligatoire",
      contact_message_min: "Minimum 10 caractères",
      contact_send: "Envoyer le message",
      contact_sending: "Envoi en cours...",
      contact_find_us: "Nous trouver",
      contact_success: "Message envoyé ! Nous vous répondrons sous 24h.",
      contact_landmark: "Près du marché central",
      contact_parking: "Parking client gratuit",
      contact_phone_hours: "Lun-Dim: 06h00-22h00",
      contact_24h_booking: "Vente 24h/24 (en ligne)",
      contact_early_departures: "Bus partent tôt le matin",
      contact_response_time: "Réponse sous 24h",
      contact_sms_followup: "Suivi par SMS/WhatsApp",

      // === PAGE MENTIONS LÉGALES ===
      legal_title: "Mentions Légales",
      legal_editor: "Éditeur du site",
      legal_company_name: "Raison sociale :",
      legal_company_name_value: "Express Abou Hamama",
      legal_legal_form: "Forme juridique :",
      legal_legal_form_value: "Entreprise individuelle",
      legal_address: "Siège social :",
      legal_address_value: "Dembe, Quartier Sabangali, Tchad",
      legal_phone: "Téléphone :",
      legal_phone_value: "+235 64 64 51 51",
      legal_email: "Email :",
      legal_email_value: "contact@expressabouhamama.td",
      legal_terms: "Conditions d'utilisation",
      legal_terms_text: "La réservation en ligne est soumise à acceptation des présentes conditions générales de vente. Les billets sont nominatifs et incessibles. Le passager doit se présenter 30 minutes avant le départ muni d'une pièce d'identité valide.",
      legal_data: "Protection des données",
      legal_data_text: "Conformément à la loi tchadienne sur la protection des données personnelles, vos informations sont collectées uniquement dans le cadre de votre réservation. Nous ne partageons pas vos données avec des tiers. Vous disposez d'un droit d'accès, de rectification et de suppression de vos données.",
      legal_payment: "Paiement",
      legal_payment_text: "Le paiement en ligne est optionnel. Vous pouvez régler à bord du bus ou dans l'une de nos agences. Les transactions par Mobile Money sont sécurisées par nos partenaires Airtel et Moov. La confirmation de paiement est envoyée par SMS et email.",

      // === ADMINISTRATION ===
      admin_login_title: "Connexion administrateur",
      admin_login_subtitle: "Accès réservé au personnel de Express Abou Hamama",
      admin_email: "Email",
      admin_password: "Mot de passe",
      admin_login_button: "Se connecter",
      admin_login_loading: "Connexion...",
      admin_login_error: "Email ou mot de passe incorrect",
      admin_logged_in_as: "Connecté en tant que :",
      admin_logout: "Se déconnecter",
      admin_panel_title: "Panneau d'administration",
      admin_verify_ticket: "Vérifier / valider un billet",
      admin_ticket_ref_placeholder: "BT-...",
      admin_ticket_phone_placeholder: "Ex: 66 00 00 00",
      admin_ticket_ref_label: "Référence du billet",
      admin_ticket_phone_label: "Téléphone du client",
      admin_ticket_ref_or_phone: "Saisissez la référence OU le téléphone",
      admin_search_button: "Rechercher la réservation",
      admin_search_loading: "Recherche en cours...",
      admin_no_ref_or_phone: "Veuillez saisir une référence OU un numéro de téléphone.",
      admin_no_results: "Aucune réservation trouvée pour ces informations.",
      admin_search_error: "Erreur lors de la recherche",
      admin_mark_paid: "Marquer comme payé",
      admin_mark_used: "Marquer comme utilisé",
      admin_bus_places: "Places par bus",
      admin_select_trip: "Sélectionnez un trajet",
      admin_select_date: "Date de voyage",
      admin_select_bus: "Numéro de bus",
      admin_select_tour: "Tour",
      admin_load_reservations: "Charger les réservations",
      admin_loading: "Chargement...",
      admin_total_places: "Places totales",
      admin_reserved_places: "Places réservées",
      admin_remaining_places: "Places restantes",
      admin_no_reservations: "Aucune réservation pour ce trajet à cette date, ce tour et ce bus",
      admin_payment_method: "Paiement",
      admin_status: "Statut",
      admin_tour_morning: "Matin",
      admin_tour_evening: "Soir",

      // === VALIDATIONS ===
      required_field: "Ce champ est obligatoire",
      invalid_email: "Email invalide",
      invalid_phone: "Téléphone invalide (format: +23566123456)",
      min_length: "Minimum {{count}} caractères",
      unknown_error: "Une erreur inconnue est survenue",
      try_again: "Réessayez",
      confirm: "Confirmer",
      cancel: "Annuler",
      save: "Enregistrer",
      edit: "Modifier",
      delete: "Supprimer",
      close: "Fermer",
      yes: "Oui",
      no: "Non",
      ok: "OK",
    }
  },
  ar: {
    translation: {
      // === COMPOSANTS GLOBAUX ===
      nav_home: "الرئيسية",
      nav_about: "من نحن",
      nav_destinations: "الوجهات",
      nav_schedule: "المواعيد",
      nav_booking: "احجز",
      nav_contact: "اتصل بنا",
      nav_legal: "الشروط القانونية",
      nav_suggestion: "💡 اقتراحات",
      bus_company: "إكسبرس أبو حمامة",
      or: "أو",
      and: "و",
      to_view_reservations: "لرؤية عدد المقاعد المحجوزة بالفعل",

      // Footer
      quick_links: "روابط سريعة",
      information: "معلومات",
      contact: "اتصال",
      agency_address: "دمبا، حي السبنجالي",
      all_rights_reserved: "جميع الحقوق محفوظة",
      footer_description: "نقل موثوق وآمن في تشاد منذ 2014",

      // === PAGE SUGGESTION ===
      suggestions_title: "اقتراحات",
      suggestions_subtitle: "شارك أفكارك لتحسين خدماتنا",
      suggestions_form_title: "اقتراحاتكم تهمن",
      suggestions_description: "ساعدنا في تحسين خدماتنا من خلال مشاركة ملاحظاتك وأفكارك أو مخاوفك.",
      email_required: "البريد الإلكتروني مطلوب",
      full_name: "الاسم الكامل *",
      email_address: "البريد الإلكتروني *",
      phone_number: "رقم الهاتف",
      suggestion_category: "الفئة *",
      select_category: "اختر فئة",
      category_service: "خدمة العملاء",
      category_booking: "الحجز",
      category_route: "مسار مقترح",
      category_price: "الأسعار",
      category_comfort: "راحة الحافلة",
      category_other: "آخر",
      category_required: "الفئة مطلوبة",
      your_suggestion: "اقتراحك *",
      suggestion_placeholder: "صف اقتراحك بالتفصيل...",
      suggestion_required: "الاقتراح مطلوب",
      suggestion_min_length: "الحد الأدنى 10 أحرف",
      sending_suggestion: "⏳ جاري الإرسال...",
      send_my_suggestion: "📨 إرسال اقتراحي",
      suggestion_success_message: "شكراً لاقتراحك! سنقوم بدراسته بعناية.",
      innovative_ideas: "أفكار مبتكرة",
      innovative_ideas_desc: "نحن منفتحون على جميع مقترحاتك لتحسين خدماتنا.",
      quick_response: "رد سريع",
      quick_response_desc: "سنرد عليك خلال 48 ساعة على أي اقتراح.",
      collaboration: "تعاون",
      collaboration_desc: "رأيك مهم ويساعدنا على التحسن كل يوم.",

      // === PAGE ACCUEIL ===
      hero_title: "سافر بأمان",
      hero_subtitle: "احجز تذكرتك عبر الإنترنت في دقيقتين",
      search_departure: "المغادرة",
      search_arrival: "الوصول",
      search_date: "التاريخ",
      search_button: "🔍 بحث",
      popular_destinations: "الوجهات الشعبية",
      popular_destinations_desc: "اختر من بين أكثر خطوطنا طلبًا",
      why_choose_us: "لماذا تختارنا؟",
      security: "ضمان الأمان",
      security_desc: "سائقون معتمدون، حافلات صيانة يومية وتأمين شامل",
      punctuality: "الالتزام بالمواعيد",
      punctuality_desc: "انطلاق في الموعد المحدد مع تتبع GPS في الوقت الفعلي",
      comfort: "راحة فاخرة",
      comfort_desc: "مقاعد مريحة، تكييف ومساحة للساقين",
      ready_to_travel: "مستعد للسفر؟",
      ready_to_travel_desc: "احجز تذكرتك الآن واستمتع برحلة مريحة وآمنة",
      book_now: "🎫 احجز الآن",
      fleet_buses: "حافلة في الأسطول",
      destinations_count: "وجهة",
      passengers_month: "مسافر/شهر",
      satisfaction_rate: "رضا",
      services_designed_for_comfort: "خدمات مصممة لراحتك",
      see_details: "انظر التفاصيل",
      travel_time: "من السفر",
      choose_departure_first: "اختر المغادرة أولاً",

      // === PAGE DESTINATIONS ===
      destinations_title: "وجهاتنا",
      destinations_subtitle: "اكتشف جميع خطوط حافلاتنا انطلاقًا من مدننا الرئيسية",
      all_routes: "الكل",
      from_ndjamena: "من انجمينا",
      morning_departures: "مغادرات الصباح",
      daily: "يوميًا",
      popular: "شعبي",
      book: "احجز",
      capacity: "55 مقعدًا",
      air_conditioned: "مكيف",
      toilets: "مراحيض",
      view_schedules: "انظر المواعيد",
      no_routes_found: "لم يتم العثور على أي مسار لهذا البحث.",
      reset_filters: "إعادة تعيين",
      starting_price: "ابتداءً من",

      // === PAGE HORAIRES ===
      schedules_title: "المواعيد والأسعار",
      schedules_subtitle: "استشر جميع مواعيدنا وابحث عن الرحلة التي تناسبك",
      route: "المسار",
      departure: "المغادرة",
      arrival: "الوصول",
      price: "السعر",
      days: "الأيام",
      action: "إجراء",
      book_ticket: "احجز",
      flexible_ticket: "تذكرة مرنة",
      flexible_ticket_desc: "تغيير مجاني حتى 24 ساعة قبل",
      secure_payment: "دفع آمن",
      secure_payment_desc: "Mobile Money أو نقدًا على متن الحافلة",
      e_ticket: "تذكرة إلكترونية",
      e_ticket_desc: "يتم استلامه عبر SMS/البريد الإلكتروني فورًا",
      duration: "المدة",
      frequency: "التردد",
      seat: "مقعد",

      // === PAGE À PROPOS ===
      about_title: "قصتنا",
      about_subtitle: "إكسبرس أبو حمامة، شركة نقل موثوقة في تشاد منذ أكثر من 10 سنوات",
      about_who_we_are: "من نحن؟",
      about_description: "إكسبرس أبو حمامة هي شركة نقل ركاب بين المدن في تشاد. نربط المدن الرئيسية في البلاد بخدمات موثوقة وآمنة ومريحة.",
      about_mission: "مهمتنا",
      about_mission_text: "تقديم نقل حديث ومتاح لجميع التشاديين، مع خدمة عملاء لا تشوبها شائبة وجداول محترمة. نضع سلامة ركابنا في صميم اهتماماتنا.",
      about_vision: "رؤيتنا",
      about_vision_text: "أن نصبح أول شركة نقل ركاب بين المدن في تشاد، معترف بها لتفوقنا التشغيلي ومساهمتنا في تطوير البلاد.",
      about_values_title: "قيمنا",
      about_values_subtitle: "ما يوجهنا كل يوم",
      about_security: "الأمان",
      about_security_desc: "سائقون معتمدون، حافلات صيانتها يومية",
      about_punctuality: "الالتزام بالوقت",
      about_punctuality_desc: "احترام صارم للمواعيد مع تتبع GPS",
      about_comfort: "الراحة",
      about_comfort_desc: "تكييف، مقاعد مريحة، مساحة واسعة",
      about_service: "الخدمة",
      about_service_desc: "فريق مكرس لرضاك",
      about_fact: "هل تعلم؟",
      about_fact_text: "أسطولنا يضم أكثر من 20 حافلة ونقلنا أكثر من 5000 مسافر شهريًا في جميع أنحاء تشاد!",

      // === PAGE RÉSERVATION ===
      search_trip: "اختر رحلتك",
      booking_title: "احجز تذكرتك",
      select_trip: "1. اختر رحلتك",
      select_seats: "2. اختر مقاعدك",
      passenger_information: "معلومات المسافر",
      first_name: "الاسم",
      last_name: "اللقب",
      phone: "رقم الهاتف",
      payment_method: "طريقة الدفع",
      airtel_money: "Airtel Money",
      moov_money: "Moov Money",
      cash_agency: "الدفع في الوكالة",
      total_to_pay: "الإجمالي للدفع",
      confirm_booking: "تأكيد الحجز",
      select_seats_first: "اختر مقعدًا واحدًا على الأقل",
      seats_selected: "المقاعد المحددة",
      seats_occupied: "المقاعد المحجوزة",
      booking_success: "✅ نجاح الحجز!",
      booking_success_message: "تم تسجيل تذكرتك في نظامنا.",
      booking_ref: "رقم مرجع الحجز:",
      download_ticket: "📄 تحميل التذكرة (صيغة التذكرة)",
      copy_ref: "نسخ المرجع",
      back_home: "العودة إلى الصفحة الرئيسية الآن",
      redirect_home: "سيتم إعادة توجيهك إلى الصفحة الرئيسية خلال دقيقة واحدة.",
      no_trip_selected: "يرجى تحديد رحلة.",
      select_at_least_one_seat: "يرجى اختيار مقعد واحد على الأقل.",
      fill_passenger_info: "يرجى ملء معلومات المسافر.",
      reservation_error: "خطأ في الحجز.",
      please_fill_all_fields: "يرجى ملء جميع الحقول",
      send_my_suggestion: "📨 إرسال اقتراحي",
      suggestion_form_title: "الاقتراحات",
      innovative_ideas: "أفكار مبتكرة",
      innovative_ideas_desc: "نحن منفتحون على جميع مقترحاتك لتحسين خدماتنا.",
      quick_response: "رد سريع",
      quick_response_desc: "سنرد عليك خلال 48 ساعة على أي اقتراح.",
      collaboration: "تعاون",

      // === PAGE CONTACT ===
      contact_title: "اتصل بنا",
      contact_subtitle: "فريقنا هنا للإجابة على جميع أسئلتك",
      contact_main_agency: "الوكالة الرئيسية",
      contact_phones: "الهواتف",
      contact_hours_value: "الاثنين-الأحد: 06h00-22h00",
      contact_email: "البريد الإلكتروني والدعم",
      contact_form_title: "نموذج الاتصال",
      contact_name: "الاسم الكامل",
      contact_name_placeholder: "جان دو بون",
      contact_name_required: "الاسم مطلوب",
      contact_name_min: "الحد الأدنى 3 أحرف",
      contact_phone: "الهاتف",
      contact_phone_placeholder: "+235 66 12 34 56",
      contact_phone_required: "الهاتف مطلوب",
      contact_phone_invalid: "شكل غير صالح (تنسيق: +23566123456)",
      contact_email: "البريد الإلكتروني",
      contact_email_placeholder: "contact@example.com",
      contact_email_invalid: "البريد الإلكتروني غير صالح",
      contact_subject: "الموضوع",
      contact_subject_select: "اختر موضوعًا",
      contact_subject_booking: "حجز",
      contact_subject_info: "معلومات",
      contact_subject_complaint: "شكوى",
      contact_subject_other: "آخر",
      contact_subject_required: "الموضوع مطلوب",
      contact_message: "الرسالة",
      contact_message_placeholder: "رسالتك التفصيلية...",
      contact_message_required: "الرسالة مطلوبة",
      contact_message_min: "الحد الأدنى 10 أحرف",
      contact_send: "إرسال الرسالة",
      contact_sending: "...جاري الإرسال",
      contact_find_us: "ابحث عنا",
      contact_success: "!تم إرسال الرسالة. سنجيب خلال 24 ساعة",
      contact_landmark: "قرب السوق المركزي",
      contact_parking: "موقف سيارات مجاني للعملاء",
      contact_phone_hours: "اثنين-أحد: 06h00-22h00",
      contact_24h_booking: "البيع 24 ساعة / 24 (عبر الإنترنت)",
      contact_early_departures: "الحافلات تغادر صباحًا مبكرًا",
      contact_response_time: "الرد خلال 24 ساعة",
      contact_sms_followup: "المتابعة عبر SMS/WhatsApp",

      // === PAGE MENTIONS LÉGALES ===
      legal_title: "الشروط القانونية",
      legal_editor: "ناشر الموقع",
      legal_company_name: "الاسم التجاري:",
      legal_company_name_value: "إكسبرس أبو حمامة",
      legal_legal_form: "الشكل القانوني:",
      legal_legal_form_value: "مؤسسة فردية",
      legal_address: "المقر الاجتماعي:",
      legal_address_value: "دمبا، حي السبنجالي، تشاد",
      legal_phone: "الهاتف:",
      legal_phone_value: "+235 64 64 51 51",
      legal_email: "البريد الإلكتروني:",
      legal_email_value: "contact@expressabouhamama.td",
      legal_terms: "شروط الاستخدام",
      legal_terms_text: "الحجز عبر الإنترنت يخضع لقبول الشروط العامة للبيع هذه. التذاكر شخصية وغير قابلة للتحويل. يجب على المسافر التواجد 30 دقيقة قبل المغادرة مع بطاقة هوية صالحة.",
      legal_data: "حماية البيانات",
      legal_data_text: "وفقًا لقانون تشاد لحماية البيانات الشخصية، يتم جمع معلوماتك فقط في إطار حجزك. لا نشارك بياناتك مع أطراف ثالثة. لديك حق الوصول إلى بياناتك وتصحيحها وحذفها.",
      legal_payment: "الدفع",
      legal_payment_text: "الدفع عبر الإنترنت اختياري. يمكنك الدفع على متن الحافلة أو في إحدى وكالاتنا. تتم حماية المعاملات عبر Mobile Money من قبل شركائنا Airtel وMoov. يتم إرسال تأكيد الدفع عبر SMS والبريد الإلكتروني.",

      // === ADMINISTRATION ===
      admin_login_title: "دخول المسؤول",
      admin_login_subtitle: "الوصول محجوز لموظفي Express Abou Hamama",
      admin_email: "البريد الإلكتروني",
      admin_password: "كلمة المرور",
      admin_login_button: "تسجيل الدخول",
      admin_login_loading: "...جاري التسجيل",
      admin_login_error: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      admin_logged_in_as: "مسجل الدخول كـ:",
      admin_logout: "تسجيل الخروج",
      admin_panel_title: "لوحة الإدارة",
      admin_verify_ticket: "التحقق من / التحقق من التذكرة",
      admin_ticket_ref_placeholder: "BT-...",
      admin_ticket_phone_placeholder: "مثال: 66 00 00 00",
      admin_ticket_ref_label: "مرجع التذكرة",
      admin_ticket_phone_label: "هاتف العميل",
      admin_ticket_ref_or_phone: "أدخل المرجع أو رقم الهاتف",
      admin_search_button: "بحث عن الحجز",
      admin_search_loading: "...جاري البحث",
      admin_no_ref_or_phone: "الرجاء إدخال مرجع أو رقم هاتف",
      admin_no_results: "لم يتم العثور على حجز لهذه المعلومات",
      admin_search_error: "خطأ في البحث",
      admin_mark_paid: "وضع علامة كمدفوع",
      admin_mark_used: "وضع علامة كمستخدم",
      admin_bus_places: "مقاعد الحافلة",
      admin_select_trip: "اختر رحلة",
      admin_select_date: "تاريخ الرحلة",
      admin_select_bus: "رقم الحافلة",
      admin_select_tour: "الجولة",
      admin_load_reservations: "تحميل الحجوزات",
      admin_loading: "...جاري التحميل",
      admin_total_places: "إجمالي المقاعد",
      admin_reserved_places: "المقاعد المحجوزة",
      admin_remaining_places: "المقاعد المتبقية",
      admin_no_reservations: "لا توجد حجوزات لهذا المسار في هذا التاريخ وهذه الجولة وهذه الحافلة",
      admin_payment_method: "طريقة الدفع",
      admin_status: "الحالة",
      admin_tour_morning: "صباحاً",
      admin_tour_evening: "مساءً",

      // === VALIDATIONS ===
      required_field: "هذا الحقل مطلوب",
      invalid_email: "البريد الإلكتروني غير صالح",
      invalid_phone: "الهاتف غير صالح (الشكل: +23566123456)",
      min_length: "الحد الأدنى {{count}} أحرف",
      unknown_error: "حدث خطأ غير معروف",
      try_again: "حاول مرة أخرى",
      confirm: "تأكيد",
      cancel: "إلغاء",
      save: "حفظ",
      edit: "تعديل",
      delete: "حذف",
      close: "إغلاق",
      yes: "نعم",
      no: "لا",
      ok: "حسنًا",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;